module.exports = function() {
  return new Worker(__webpack_public_path__ + "61f33d06a482c4cf10bb.worker.js");
};